export default __webpack_public_path__ + "static/media/mobile7.02ded876.jfif";